import { SignExport } from './proposal';

export interface UserPreferences {
  adkomDefaultExport: string;
}

export interface OrganizationPreferences {
  adkomExports: Array<SignExport>;
}
